/* eslint-disable ember/no-classic-components, ember/no-computed-properties-in-native-classes, ember/require-tagless-components */
import { tracked } from '@glimmer/tracking';
import Component from '@ember/component';
import { computed } from '@ember/object';
import { service } from '@ember/service';
import Options from '@linc-technologies/linced-common/enums/options';
import { optionAlias } from '@linc-technologies/linced-common/utils/options';

export default class AchievementStatement extends Component {
  // Services
  @service
  options;

  // Attrs
  @optionAlias(Options.EXPECTATIONS_SHOW_ACHIEVEMENT_STATEMENTS)
  _showAchievementStatements;

  @optionAlias(Options.EXPECTATIONS_SHOW_ACHIEVEMENT_STATEMENTS_STAFF)
  _showAchievementStatementsStaff;

  @computed(
    'isParentView',
    '_showAchievementStatements',
    '_showAchievementStatementsStaff',
  )
  get showAchievementStatements() {
    if (this.isParentView) {
      return this._showAchievementStatements;
    }
    return this._showAchievementStatementsStaff;
  }

  @optionAlias(Options.EXPECTATIONS_INCLUDE_CURRICULUM_LEVEL)
  _includeCurriculumLevel;

  @optionAlias(Options.EXPECTATIONS_INCLUDE_CURRICULUM_LEVEL_STAFF)
  _includeCurriculumLevelStaff;

  @computed(
    'isParentView',
    '_includeCurriculumLevel',
    '_includeCurriculumLevelStaff',
  )
  get includeCurriculumLevel() {
    if (this.isParentView) {
      return this._includeCurriculumLevel;
    }
    return this._includeCurriculumLevelStaff;
  }

  @optionAlias(Options.EXPECTATIONS_INCLUDE_MILESTONE)
  _includeMilestone;

  @optionAlias(Options.EXPECTATIONS_INCLUDE_MILESTONE_STAFF)
  _includeMilestoneStaff;

  @computed('isParentView', '_includeMilestone', '_includeMilestoneStaff')
  get includeMilestone() {
    if (this.isParentView) {
      return this._includeMilestone;
    }
    return this._includeMilestoneStaff;
  }

  includeLegalName = false;
  @tracked isParentView = false;

  // Props
  // person provides the person to generate an achievement statement for.
  person = null;

  // subjectData contains a computed progressions data object to use to
  // generate the achievement statement.
  subjectData = null;
}
